import React, { useState } from "react";
import { connect } from "react-redux";
import { createStore } from "devextreme-aspnet-data-nojquery";
import LocationSearchFormResult from "../maintabs/location/LocationSearchFormResult";
import LocationtSearchForm from "../maintabs/location/LocationtSearchForm";

const WMLocationDetails = (props) => {
    const orderStatus = "0";
    const getDataUrl = "wm/Location/GetLocations";
    const [dataSource, setDataSource] = useState(null);
    const [pageTitle, setPageTitle] = useState("Locations");
    const accessToken = props.oidc.user.access_token;

    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: "rowId",
            loadParams: {
                Warehouse: () => formFields.Warehouse,
                Location: () => formFields.Location,
                Description: () => formFields.Description,
                Classcode: () => formFields.Classcode,
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };

    const searchData = (formFields) => {
        const resultData = GetGridData(accessToken, getDataUrl, formFields);
        setDataSource(resultData);
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LocationtSearchForm pageTitle={pageTitle} searchData={searchData} />
                        <LocationSearchFormResult data={dataSource} />
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMLocationDetails);
